<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <HelpAndTournamentsModal ref="helpAndTournamentModal" :languages="languages"></HelpAndTournamentsModal>
            <button class="btn btn-primary" v-on:click="$refs.helpAndTournamentModal.show()"><i class="fas fa-language"></i> Help & Tournaments</button>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row" id="loading-container">
          <div class="col-md-3">
            <div class="card">
              <div class="card-header p-3 bg-light">
                Translation groups
                <button id="add-group-btn" class="ml-2 btn btn-outline-primary btn-xs btn-control float-right"><i class="fa fa-plus"></i></button>
                <b-popover ref="addGroupPopover" right target="add-group-btn" title="Create translation group">
                  <form @submit.prevent="createGroup($event)" class="">
                    <div class="form-group">
                      <input name="name" type="text" class="form-control form-control-sm" value="">
                      <div class="invalid-feedback"></div>
                    </div>
                    <div class="d-flex justify-content-end m-0 form-group">
                      <button type="button" @click="$refs.addGroupPopover.$emit('close')" class="btn btn-light btn-sm">Cancel</button>
                      <button type="submit" class="ml-2 btn btn-success btn-sm">Create</button>
                    </div>
                  </form>
                </b-popover>
              </div>
              <div style="height: calc(100vh - 260px); overflow-y: auto;">
                <nav class="mt-2">
                  <ul class="nav nav-pills nav-sidebar nav-child-indent flex-column text-capitalize" data-accordion="false" data-widget="treeview" role="menu">
                    <li v-for="group in sortedGroups" :key="group.id" class="nav-item" :class="{'menu-open': isGroupOpened(group)}">
                      <a href="#" class="nav-link" @click.prevent="toggleGroup(group)">
                        <i class="fas fa-angle-right"></i>
                        {{ group.name }}

                        <div data-toggle="buttons" class="btn-group btn-group-toggle" style="float:right">
                          <button :id="'add-term-btn-' + group.id" @click.stop class="btn btn-outline-primary btn-xs btn-control"><i class="fa fa-plus"></i></button>
                          <b-popover
                            :ref="'addTermPopover' +  group.id"
                            placement="right"
                            boundary="window"
                            :target="'add-term-btn-' + group.id"
                            :title="'Create translation in group \'' + group.name + '\''"
                            @show="onAddTermPopoverShow(group)"
                          >
                            <form @submit.prevent="createTerm(group, $event)" class="">
                              <div class="form-group">
                                <input name="name" type="text" class="form-control form-control-sm">
                                <div class="invalid-feedback"></div>
                              </div>
                              <div class="d-flex justify-content-end m-0 form-group">
                                <button type="button" @click="closePopover('addTermPopover' + group.id)" class="btn btn-light btn-sm">Cancel</button>
                                <button type="submit" class="ml-2 btn btn-success btn-sm">Create</button>
                              </div>
                            </form>
                          </b-popover>

                          <button :id="'edit-group-btn-' + group.id" @click.stop class="btn btn-outline-success btn-xs btn-control"><i class="fa fa-pen"></i></button>
                          <b-popover
                            :ref="'editGroupPopover' +  group.id"
                            placement="right"
                            boundary="window"
                            :target="'edit-group-btn-' + group.id"
                            :title="'Edit translation group \'' + group.name + '\''"
                            @show="onEditGroupPopoverShow(group)"
                          >
                            <form @submit.prevent="saveGroup(group, $event)" class="">
                              <div class="form-group">
                                <input :value="group.name" name="name" type="text" class="form-control form-control-sm">
                                <div class="invalid-feedback"></div>
                              </div>
                              <div class="d-flex justify-content-end m-0 form-group">
                                <button type="button" @click="closePopover('editGroupPopover' + group.id)" class="btn btn-light btn-sm">Cancel</button>
                                <button type="submit" class="ml-2 btn btn-success btn-sm">Save</button>
                              </div>
                            </form>
                          </b-popover>

                          <button :id="'remove-group-btn-' + group.id" @click.stop class="btn btn-outline-danger btn-xs btn-control"><i class="fa fa-times"></i></button>
                          <b-popover :ref="'deleteGroupPopover' +  group.id" placement="right" boundary="window" :target="'remove-group-btn-' + group.id" :title="'Delete translation group \'' + group.name + '\'?'">
                            <div class="d-flex justify-content-end m-0 form-group">
                              <button type="button" @click="closePopover('deleteGroupPopover' + group.id)" class="btn btn-light btn-sm">Cancel</button>
                              <button type="button" @click="deleteGroup(group)" class="ml-2 btn btn-danger btn-sm">Delete</button>
                            </div>
                          </b-popover>
                        </div>

                      </a>
                      <ul  class="nav nav-sidebar nav-treeview">
                        <li v-for="term in getGroupTerms(group)" :key="term.id" class="nav-item">
                          <a class="nav-link" :class="{'selected' : isTermSelected(term)}" href="#" @click.prevent="selectTerm(term, group)">
                            {{ term.name }}

                            <div data-toggle="buttons" class="btn-group btn-group-toggle" style="float:right">
                              <button :id="'edit-term-btn-' + term.id" @click.stop class="btn btn-outline-success btn-xs btn-control"><i class="fa fa-pen"></i></button>
                              <b-popover
                                :ref="'editTermPopover' +  term.id"
                                placement="right"
                                boundary="window"
                                :target="'edit-term-btn-' + term.id"
                                :title="'Edit translation \'' + group.name + '.' + term.name + '\''"
                                @show="onEditTermPopoverShow(term)"
                              >
                                <form @submit.prevent="saveTerm(term, $event)" class="">
                                  <div class="form-group">
                                    <input :value="term.name" name="name" type="text" class="form-control form-control-sm">
                                    <div class="invalid-feedback"></div>
                                  </div>
                                  <div class="d-flex justify-content-end m-0 form-group">
                                    <button type="button" @click="closePopover('editTermPopover' + term.id)" class="btn btn-light btn-sm">Cancel</button>
                                    <button type="submit" class="ml-2 btn btn-success btn-sm">Save</button>
                                  </div>
                                </form>
                              </b-popover>

                              <button :id="'remove-term-btn-' + term.id" @click.stop class="btn btn-outline-danger btn-xs btn-control"><i class="fa fa-times"></i></button>
                              <b-popover :ref="'deleteTermPopover' +  term.id" placement="right" boundary="window" :target="'remove-term-btn-' + term.id" :title="'Delete translation \'' + group.name + '.' + term.name + '\'?'">
                                <div class="d-flex justify-content-end m-0 form-group">
                                  <button type="button" @click="closePopover('deleteTermPopover' + term.id)" class="btn btn-light btn-sm">Cancel</button>
                                  <button type="button" @click="deleteTerm(term)" class="ml-2 btn btn-danger btn-sm">Delete</button>
                                </div>
                              </b-popover>
                            </div>

                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div class="col-md-9">
            <div class="card">
              <div class="card-header p-3 bg-light">
                Translations
                <button :disabled="deployBtnDisabled || isUpdating"
                        @click="deploy"
                        class="ml-2 btn btn-outline-primary btn-xs btn-control float-right"
                        title="Deploy"
                >
                  <i :class="deployBtnIcon"></i>
                </button>
                <button @click="$refs.statsModal.toggle()" class="ml-2 btn btn-outline-primary btn-xs btn-control float-right" title="Languages"><i class="fa fa-cog"></i></button>
                <button @click="$refs.exportModal.toggle()" class="ml-2 btn btn-outline-primary btn-xs btn-control float-right" title="Export"><i class="fa fa-upload"></i></button>
                <button @click="$refs.importModal.toggle()" class="ml-2 btn btn-outline-primary btn-xs btn-control float-right" title="Import"><i class="fa fa-download"></i></button>
              </div>
              <div v-if="this.selectedTerm || this.selectedGroup" style="height: calc(100vh - 260px); overflow-y: auto;">
                <div v-for="term in (selectedTerm ? [selectedTerm] : getGroupTerms(selectedGroup))" :key="term.id">
                  <div class="card-header">{{ selectedGroup.name }}.{{ term.name }}</div>
                  <div class="p-3">
                    <div v-for="language in languages" :key="language.id" class="d-flex align-items-center form-group">
                      <label class="m-0 form-label" style="width: 30px;">{{ language.code }}</label>
                      <div class="flex-grow-1">
                        <input @change="updateTranslation(term, language, $event)"
                               name="text"
                               type="text"
                               class="form-control form-control-sm"
                               :value="getTransText(term, language)"
                               :ref="getInputRef(term, language)"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <StatsModal ref="statsModal"
                      :disabled-codes="['en']"
                      :languages="this.languages"
                      :translations="this.translations"
                      :terms="this.terms"
                      :hidden-codes="[]"
                      @languageRemoved="languageRemoved($event)"
                      @languageChanged="languageChanged($event)"
                      @languageCreated="languageCreated($event)"
          />
          <ExportModal ref="exportModal"
                       :languages="this.languages"
          />
          <ImportModal ref="importModal"
                       :languages="this.languages"
                       @onComplete="loadData"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<style>
.nav-link.selected {
  font-weight: bold;
}

.nav-sidebar .menu-is-opening>.nav-link i.fa-angle-right, .nav-sidebar .menu-open>.nav-link i.fa-angle-right {
  transform: rotate(90deg);
}
.btn-control.btn-xs {
  width: 25px;
}
</style>

<script>

import {getRouteIcon, ROUTE_LOCALIZATION} from "../../utils/routerIcons";
import StatsModal from "../../components/Localization/LegacyStatsModal";
import ExportModal from "../../components/Localization/LegacyExportModal";
import ImportModal from "../../components/Localization/LegacyImportModal";
import HelpAndTournamentsModal from "../../components/Localization/HelpAndTournamentsModal";

export default {
  data() {
    return {
      openedGroups: [],
      groups: [],
      terms: [],
      translations: [],
      languages: [],
      selectedTerm: null,
      selectedGroup: null,
      deployBtnDisabled: false,
      isUpdating: false,
    }
  },
  components: {
    StatsModal,
    ExportModal,
    ImportModal,
    HelpAndTournamentsModal,
  },
  computed: {
    deployBtnIcon() {
      return this.deployBtnDisabled ? 'fas fa-spinner fa-pulse' : 'fa fa-share-square';
    },
    routeIcon: () => getRouteIcon(ROUTE_LOCALIZATION),
    sortedGroups: function () {
      return this.groups.slice().sort((a, b) => a.name > b.name ? 1 : -1)
    }
  },
  methods: {
    languageChanged(lang) {
      let changedLang = this.languages.filter((el) => el.id === lang.id)[0];
      if (!changedLang) {
        return;
      }
      changedLang.code = lang.code;
      changedLang.name = lang.name;
    },
    languageCreated(lang) {
      this.languages.push(lang);
    },
    languageRemoved(langId) {
      this.languages = this.languages.filter((el) => el.id !== langId);
    },
    deploy() {
      if (this.isUpdating) {
        return;
      }

      if (this.deployBtnDisabled) {
        return;
      }

      this.deployBtnDisabled = true;
      this.$http({
        url: '/api/v1/localization/deploy',
        method: 'POST',
      })
          .then((res) => {
            let {deployedLanguages, failedLanguages, errors} = res.data;

            if (deployedLanguages.length > 0) {
              this.$toastr.i('Deployed: ' + deployedLanguages.join(', '));
            }

            if (failedLanguages.length > 0) {
              this.$toastr.e('Failed: ' + failedLanguages.join(', '));
            }

            if (errors.length > 0) {
              this.$toastr.e('Errors: ' + errors.join(', '));
            }
          })
          .catch((err) => {
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
          .finally(() => {
            this.deployBtnDisabled = false;
          })
    },
    getInputRef(term, language) {
      return 'input-' + term.id + '-' + language.id;
    },
    updateTranslation(term, language, $event) {
      let text = $event.target.value;
      if (text === this.getTransText(term, language)) {
        return;
      }

      this.isUpdating = true;

      let $ref = this.$refs[this.getInputRef(term, language)];
      $ref[0].disabled = true;

      this
          .$http({
            url: '/api/v1/localization/translations',
            method: 'POST',
            data: {
              termId: term.id,
              languageId: language.id,
              text: text
            },
            headers: {'Content-Type': 'application/json'},
          })
          .then(resp => {
            let trans = resp.data;
            let existedTrans = this.translations.filter((el) => el.id === trans.id)[0];
            if (!existedTrans) {
              existedTrans = trans;
              this.translations.push(existedTrans);
            }
            existedTrans.text = text;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            $ref[0].disabled = false;
            this.isUpdating = false;
          })
    },
    onEditTermPopoverShow() {
      this.$root.$emit('bv::hide::popover');
    },
    onAddTermPopoverShow() {
      this.$root.$emit('bv::hide::popover');
    },
    onEditGroupPopoverShow() {
      this.$root.$emit('bv::hide::popover');
    },
    closePopover(ref) {
      this.$refs[ref][0].$emit('close');
    },
    deleteGroup(group) {
      this
          .$http({
            url: '/api/v1/localization/groups/' + group.id,
            method: 'DELETE',
          })
          .then(() => {
            this.groups = this.groups.filter((el) => el.id !== group.id);
            this.$refs['deleteGroupPopover' + group.id][0].$emit('close');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
    },
    deleteTerm(term) {
      this
          .$http({
            url: '/api/v1/localization/terms/' + term.id,
            method: 'DELETE',
          })
          .then(() => {
            this.terms = this.terms.filter((el) => el.id !== term.id);
            this.$refs['deleteTermPopover' + term.id][0].$emit('close');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
    },
    createTerm(group, $event) {
      let name = $event.target.elements.name.value;
      if (!name) {
        return;
      }

      this
          .$http({
            url: '/api/v1/localization/terms',
            method: 'POST',
            data: {
              name: name,
              groupId: group.id
            },
            headers: {'Content-Type': 'application/json'},
          })
          .then(resp => {
            this.terms.push(resp.data);
            this.$refs['addTermPopover' + group.id][0].$emit('close');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
    },
    saveTerm(term, $event) {
      let name = $event.target.elements.name.value;
      if (!name) {
        return;
      }

      this
          .$http({
            url: '/api/v1/localization/terms/' + term.id,
            method: 'PUT',
            data: {
              name: name,
              groupId: term.groupId
            },
            headers: {'Content-Type': 'application/json'},
          })
          .then(() => {
            term.name = name;
            this.$refs['editTermPopover' + term.id][0].$emit('close');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
    },
    saveGroup(group, $event) {
      let name = $event.target.elements.name.value;
      if (!name) {
        return;
      }

      this
          .$http({
            url: '/api/v1/localization/groups/' + group.id,
            method: 'PUT',
            data: {
              name: name
            },
            headers: {'Content-Type': 'application/json'},
          })
          .then(() => {
            group.name = name;
            this.$refs['editGroupPopover' + group.id][0].$emit('close');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
    },
    createGroup($event) {
      let name = $event.target.elements.name.value;
      if (!name) {
        return;
      }

      this
          .$http({
            url: '/api/v1/localization/groups',
            method: 'POST',
            data: {
              name: name
            },
            headers: {'Content-Type': 'application/json'},
          })
          .then(resp => {
            this.groups.push(resp.data);
            this.$refs.addGroupPopover.$emit('close');
          })
          .catch((err) => {
            console.log(err);
            this.$toastr.e(typeof err.response.data.message === 'string' ? err.response.data.message : JSON.stringify(err.response.data.message));
          })
    },
    isTermSelected(term) {
      if (!this.selectedTerm) {
        return false;
      }
      return this.selectedTerm.id === term.id;
    },
    getTransText(term, lang) {
      let trans = this.translations.filter(trans => trans.termId === term.id && trans.languageId === lang.id)[0];
      if (trans) {
        return trans.text
      }
      return '';
    },
    selectTerm(term, group) {
      this.selectedTerm = term;
      this.selectedGroup = group;
    },
    isGroupOpened(group) {
      return this.openedGroups.indexOf(group.id) >= 0;
    },
    toggleGroup(group) {
      if (!this.isGroupOpened(group)) {
        this.openedGroups.push(group.id);
        this.selectTerm(null, group)
      } else {
        this.openedGroups = this.openedGroups.filter(item => item !== group.id);
      }
    },
    getGroupTerms(group) {
      return this.terms
        .filter((term) => term.groupId === group.id)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    loadData() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });
      loadingInstance.show();

      Promise.all([
        this
            .$http({
              url: '/api/v1/localization/groups',
              method: 'GET',
            })
            .then(resp => {
              this.groups = resp.data;
            }),
        this
            .$http({
              url: '/api/v1/localization/terms',
              method: 'GET',
            })
            .then(resp => {
              this.terms = resp.data;
            }),
        this
            .$http({
              url: '/api/v1/localization/translations',
              method: 'GET',
            })
            .then(resp => {
              this.translations = resp.data;
            }),
        this
            .$http({
              url: '/api/v1/localization/languages',
              method: 'GET',
            })
            .then(resp => {
              this.languages = resp.data;
            })
      ])
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });

    }
  },
  mounted() {
    this.loadData();
  }
}
</script>
